import Talent from '../attributes/talent';

export const enum Category {
  Resource,
  Attribute,
  Talent,
  Magic,
  Maneouvre,
}

export const enum Resources {
  lep = 'Lebensenergie',
  aip = 'Ailfar',
  ini = 'Initiative',
  ep = 'Erfahrungspunkte',
  myp = 'Mystikpunkte',
  wap = 'Waffenpunkte',
  hp = 'Heldenpunkte',
}

export const enum Attributes {
  sta = 'Stärke',
  kon = 'Kondition',
  wen = 'Wendigkeit',
  ges = 'Geschick',
  tap = 'Tapferkeit',
  sel = 'Seelenstärke',
  int = 'Intuition',
  sch = 'Schläue',
  wei = 'Weisheit',
  bil = 'Bildung',
  cha = 'Charisma',
  auf = 'Auftreten',
}

export const enum Elements {
  feuer = 'Feuer',
  wind = 'Wind',
  erde = 'Erde',
  wasser = 'Wasser',
  licht = 'Licht',
  schatten = 'Schatten',
  blut = 'Blut',
  nebel = 'Nebel',
}

export const enum TalentField {
  Körper,
  Wildnis,
  Geist,
  Gasse,
  Wissen,
  Mystik,
}

export class AvatarTalent extends Talent {
  public constructor(name: string, field: TalentField) {
    super(name, field);
    this.isAvatarsTalent = true;
  }
}

export const Talents: Talent[] = [
  // Körper
  new Talent('Akrobatik', TalentField.Körper),
  new Talent('Askese', TalentField.Körper),
  new Talent('Flüchten', TalentField.Körper),
  new Talent('Klettern', TalentField.Körper),
  new Talent('Kraftakte', TalentField.Körper),
  new Talent('Reiten', TalentField.Körper),
  new Talent('Schleichen', TalentField.Körper),
  new Talent('Schwimmen', TalentField.Körper),
  new Talent('Sinnenschärfe (Fühlen)', TalentField.Körper),
  new Talent('Sinnenschärfe (Hören)', TalentField.Körper),
  new Talent('Sinnenschärfe (Riechen)', TalentField.Körper),
  new Talent('Sinnenschärfe (Sehen)', TalentField.Körper),
  new Talent('Springen', TalentField.Körper),
  new Talent('Sprinten', TalentField.Körper),
  new Talent('Verstecken', TalentField.Körper),
  new AvatarTalent('Zähigkeit', TalentField.Körper),
  // Wildnis
  new Talent('Abrichten', TalentField.Wildnis),
  new Talent('Boote fahren', TalentField.Wildnis),
  new Talent('Erkunden', TalentField.Wildnis),
  new Talent('Fremde Völker', TalentField.Wildnis),
  new Talent('Jagd', TalentField.Wildnis),
  new Talent('Luftfahrt', TalentField.Wildnis),
  new AvatarTalent('Marschieren', TalentField.Wildnis),
  new Talent('Pflanzenkunde', TalentField.Wildnis),
  new Talent('Rudern', TalentField.Wildnis),
  new Talent('Tarnen', TalentField.Wildnis),
  new Talent('Tierkunde', TalentField.Wildnis),
  new Talent('LufWaldläuferkniffetfahrt', TalentField.Wildnis),
  new Talent('Wetterkunde', TalentField.Wildnis),
  // Geist
  new AvatarTalent('Auffassungsgabe', TalentField.Geist),
  new Talent('Betören', TalentField.Geist),
  new Talent('Einschüchtern', TalentField.Geist),
  new Talent('Eisenstirn', TalentField.Geist),
  new Talent('Empathie', TalentField.Geist),
  new Talent('Gefahrensinn', TalentField.Geist),
  new Talent('Glücksspiel', TalentField.Geist),
  new Talent('Kommando', TalentField.Geist),
  new Talent('Mission', TalentField.Geist),
  new AvatarTalent('Nervenstärke', TalentField.Geist),
  new Talent('Überreden', TalentField.Geist),
  new Talent('Überzeugen', TalentField.Geist),
  // Gasse
  new Talent('Abläufe', TalentField.Gasse),
  new Talent('Brauchtum', TalentField.Gasse),
  new Talent('Diebstahl', TalentField.Gasse),
  new Talent('Einbruch & Öffnen', TalentField.Gasse),
  new Talent('Etikette', TalentField.Gasse),
  new Talent('Ganoventum', TalentField.Gasse),
  new Talent('Gassenkunde', TalentField.Gasse),
  new Talent('Handeln', TalentField.Gasse),
  new Talent('Hierarchien', TalentField.Gasse),
  new Talent('Spurensuche', TalentField.Gasse),
  new Talent('Verkleiden', TalentField.Gasse),
  new AvatarTalent('Vernetzen', TalentField.Gasse),
  // Wissen
  new Talent('Aeronautik', TalentField.Wissen),
  new Talent('Alchemie', TalentField.Wissen),
  new Talent('Anatomie', TalentField.Wissen),
  new Talent('Arkanomechanik', TalentField.Wissen),
  new Talent('Baukunst', TalentField.Wissen),
  new Talent('Botanik', TalentField.Wissen),
  new Talent('Finanzen', TalentField.Wissen),
  new Talent('Gesteinskunde', TalentField.Wissen),
  new Talent('Geografie', TalentField.Wissen),
  new Talent('Historik', TalentField.Wissen),
  new AvatarTalent('Kombinatorik', TalentField.Wissen),
  new Talent('Kriegskunst', TalentField.Wissen),
  new Talent('Lehren', TalentField.Wissen),
  new Talent('Lesen & Schreiben', TalentField.Wissen),
  new Talent('Mechanik', TalentField.Wissen),
  new Talent('Nautik', TalentField.Wissen),
  new Talent('Psychologie', TalentField.Wissen),
  new Talent('Recherche', TalentField.Wissen),
  new Talent('Rüstungskunde', TalentField.Wissen),
  new Talent('Sprachenkunde', TalentField.Wissen),
  new Talent('Volkskunde', TalentField.Wissen),
  new Talent('Vyszik', TalentField.Wissen),
  new Talent('Waffenkunde', TalentField.Wissen),
  new Talent('Zoologie', TalentField.Wissen),
  // Mystik
  new Talent('Archaik', TalentField.Mystik),
  new Talent('Artefaktkunde', TalentField.Mystik),
  new Talent('Astraleik', TalentField.Mystik),
  new Talent('Bardentum', TalentField.Mystik),
  new Talent('Bestienkunde', TalentField.Mystik),
  new Talent('Elementarkunde', TalentField.Mystik),
  new Talent('Fokuswirken', TalentField.Mystik),
  new Talent('Hexenkunst', TalentField.Mystik),
  new Talent('Meditation', TalentField.Mystik),
  new AvatarTalent('Prophezeien', TalentField.Mystik),
  new Talent('Sternkunde', TalentField.Mystik),
  new Talent('Teufelskunde', TalentField.Mystik),
  new Talent('Theologie', TalentField.Mystik),
  new Talent('Zauberkunde', TalentField.Mystik),
  new Talent('Zeichenkunde', TalentField.Mystik),
];
